module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fc-Ge-Hc-Ic-Ja.a425035a.png";